"use strict";

Shopify.theme.jsSlideshowWithText1 = {
  init: function init($section) {
    

    var $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
    
    var $imageSlideshow = $imageSlideshowEl.flickity({
      contain: true,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape
    });
  
 
    $section.find('.flickity-button').wrapAll('<div class="seven-twelfths medium-down--one-whole flickity-buttons-container custom-container"></div>');
  },
 
  unload: function unload($section) {
    $section.find('.flickity-button').unwrap();
  }
};